/** Per-app rules for the Task Detail surface; each app registers its own at root, none borrows another's. */
import { inject, Provider } from '@angular/core';
import { getPortalContractorSectionRights, PortalContractorSecurityRight, Task } from '@jms/model';
import { RightsService } from '@jms/utils/util.permissions';
import { webTaskDetailRights } from '@workbuddy/ui/modules/tasks/src/models';
import { TaskDetailRights, TASK_DETAIL_RIGHTS } from './surface/detail/task.detail.rights';

/** The web app: Tasks module rights, plus the Tasks section rights on a job task. The role is read per task, since it changes on sign-in. */
export const webTaskDetailRightsProvider: Provider = {
  provide: TASK_DETAIL_RIGHTS,
  useFactory: () => {

    const rights = inject(RightsService);

    return (task: Task): TaskDetailRights => webTaskDetailRights(rights.role, task);
  },
};

/**
 * The Contractor Portal: a subcontractor changes status and evidence only, fields stay locked (WBS-12027), and only
 * with the portal Tasks › Edit (WBS-12242). Whether the stage is theirs arrives as the board's `readonly`, and the
 * server holds the rest (WBS-11934).
 */
export const contractorPortalTaskDetailRightsProvider: Provider = {
  provide: TASK_DETAIL_RIGHTS,
  useFactory: () => {

    const rights = inject(RightsService);

    // A subcontractor reopens a submitted form with the portal right, never the tenant Forms one.
    return (): TaskDetailRights => {

      const edit = getPortalContractorSectionRights(rights.role).tasks.edit;

      return { canManage: edit, canEditFields: false, canAddEvidence: edit, canModifySubmittedForm: edit && rights.hasRights(PortalContractorSecurityRight.ModifyFormAfterSubmission) };
    };
  },
};
